<template>
  <v-app>
    <head>
      <!-- TODO : 이 부분 중복해서 들어가지 않는지 확인 필요 -->
      <link href='https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons' rel="stylesheet">
    </head>
    <div v-if="isLoggedIn() === true">
      <v-app-bar app>
        <v-toolbar-title class="text-h5 text-uppercase">
          <span>SIENG </span>
          <span class="font-weight-light"> management system</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>

        <v-progress-circular indeterminate v-if="loading"/>

        <v-toolbar-items>
          <v-btn tile text to="/">
            <v-icon>insert_chart_outlined</v-icon>
            현장정보
          </v-btn>
          <v-btn tile text to="/site">
            <v-icon>build</v-icon>
            현장관리
          </v-btn>
          <v-btn v-if="higherUserLevel(1)" tile text to="/user">
            <v-icon>person</v-icon>
            회원관리
          </v-btn>
          <v-btn v-if="isAdmin()" tile text to="/debug">
            <v-icon>report</v-icon>
            개발테스트
          </v-btn>
          <v-menu>
            <template v-slot:activator="{ on }">
              <v-btn tile text v-on="on">{{ loginInfo.loginId }}</v-btn>
            </template>
            <!-- min-width 부분은 IE11에서 발생하는 버그때문에 삽입됨 https://github.com/vuetifyjs/vuetify/issues/8338 -->
            <v-list min-width="150">
              <v-list-item
                v-for="(menuItem, index) in myAccountMenu" :key="'myAccountMenu' + index"
                @click="menuItem.value(menuItem.arg)"
              >
                <!-- 이 부분은 IE11에서 발생하는 버그때문에 삽입됨 https://github.com/vuetifyjs/vuetify/issues/8338 -->
                <div style="height: 48px;"></div>
                <v-list-item-title>{{ menuItem.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar-items>
      </v-app-bar>

      <v-dialog v-model="dialog.updateDialog" max-width="800">
        <UpdateMyAccountDialog :dialog="dialog" :item="myAccountInfo"/>
      </v-dialog>
      <v-dialog v-model="dialog.updatePasswordDialog" max-width="800">
        <UpdateMyAccountPasswordDialog :dialog="dialog" :item="myAccountInfo"/>
      </v-dialog>

      <v-main>
        <router-view/>
      </v-main>

      <v-footer app>
        <span>SIENG</span>
      </v-footer>
    </div>
    <div v-else>
      <v-main>
        <Login/>
      </v-main>
    </div>
    <alert-snackbar/>
  </v-app>
</template>

<script>
  import Login from './components/Login'
  import AlertSnackbar from './components/AlertSnackbar'
  import axios from 'axios'
  import hash from 'hash.js'
  import VueCookies from 'vue-cookies'

  import UpdateMyAccountDialog from "./components/my-account/UpdateMyAccountDialog";
  import UpdateMyAccountPasswordDialog from "./components/my-account/UpdateMyAccountPasswordDialog";

  export default {
    name: 'App',
    components: {
      Login,
      AlertSnackbar,
      UpdateMyAccountDialog,
      UpdateMyAccountPasswordDialog
    },
    data() {
      return {
        loading: false,
        loginInfo: {
          loginId: '',
          accessToken: '',
          refreshToken: '',
          userLevel: 0,
        },
        myAccountMenu: [
          {text: '내 정보 수정', value: this.openDialog, arg: 'updateDialog' },
          {text: '비밀번호 변경', value: this.openDialog, arg: 'updatePasswordDialog' },
          {text: '로그아웃', value: this.logout, arg: '' },
        ],
        dialog: {
          updateDialog: false,
          updatePasswordDialog: false,
        },
        myAccountInfo: {}
      }
    },
    methods: {
      setLoading(loading) {
        this.loading = loading;
      },
      isEmpty(str) {
        return (str === 0 || !str.trim());
      },
      isLoggedIn() {
        return !this.isEmpty(this.loginInfo.loginId);
      },
      isAdmin() {
        const loginIdHash = hash.sha256().update(this.loginInfo.loginId).digest('hex');
        const adminHash = 'd0d576e9144f417fe756d38893d7648f81b7b5c2f9ed39596571cdc80af1963b';
        console.log(`loginIdHash : ${loginIdHash} | adminHash : ${adminHash}`);
        return loginIdHash === adminHash;
      },
      higherUserLevel(targetUserLevel) {
        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        console.log(`userLevel : ${siengLoginInfoCookie.userLevel}`);
        console.dir(siengLoginInfoCookie);
        return siengLoginInfoCookie.userLevel > targetUserLevel;
      },
      login(loginId, password) {
        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/auth/login`;

        this.$bus.$emit('loading', true);
        const loginData = {
          loginId: loginId,
          password: password
        };

        axios.post(targetUri, loginData)
          .then(result => {
            this.loginInfo.accessToken = result.data.accessToken;
            this.loginInfo.refreshToken = result.data.refreshToken;
            this.loginInfo.userLevel = result.data.userLevel;
            this.loginInfo.loginId = loginData.loginId;

            console.dir(this.loginInfo);
            $cookies.set('siengLoginInfo', this.loginInfo, '6h');
          })
          .catch(error => {
            error.hasOwnProperty('response') ? console.error(error.response) : console.error(error);
            this.popupAlert('로그인에 실패하였습니다.', 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });

      },
      logout() {
        this.loginInfo.loginId = '';
        $cookies.remove('siengLoginInfo');
      },
      getMyAccountInfo() {
        const retryFuncBackup = this.getMyAccountInfo.bind(this);

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/users/_self`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const config = {
          headers: {
            Authorization: `Bearer ${siengLoginInfoCookie.accessToken}`
          }
        };

        return axios.get(targetUri, config)
          .then(result => {
            this.myAccountInfo = result.data;
          })
          .catch(error => {
            if (!error.hasOwnProperty('response')) {
              console.error(error);
              this.popupAlert(error.toString(), 'red');
              return;
            }

            if (error.response.status === 401 && "TOKEN_REFRESH_NEEDED" === error.response.data.detailedErrorCode) {
              this.$bus.$emit('refreshTokenAndRetryIfPossible', error, retryFuncBackup);
              return;
            }

            console.error(error.response);
            this.popupAlert(error.toString(), 'red');
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      refreshTokenAndRetryIfPossible(error, backupFunc) {
        console.log("refreshToken invoked!!");

        const baseUri = process.env.VUE_APP_API_SERVER;
        const targetUri = `${baseUri}/auth/refresh`;

        this.$bus.$emit('loading', true);

        const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
        const data = {
          refreshToken: siengLoginInfoCookie.refreshToken
        };

        axios.post(targetUri, data)
          .then(result => {
            this.loginInfo.accessToken = result.data.accessToken;
            this.loginInfo.refreshToken = result.data.refreshToken;

            console.dir(this.loginInfo);
            $cookies.set('siengLoginInfo', this.loginInfo, '6h');

            // 백업받았던 함수를 다시 재실행한다.
            backupFunc();
          })
          .catch(error => {
            error.hasOwnProperty('response') ? console.error(error.response) : console.error(error);
            this.logout();
          })
          .finally(() => {
            this.$bus.$emit('loading', false);
          });
      },
      openDialog(dialogName) {
        this.getMyAccountInfo()
          .then(() => {
            this.dialog[dialogName] = true;
          });
      },
      popupAlert(message, color) {
        this.$bus.$emit('popupAlert', {message: message, color: color});
      }
    },
    // TODO : 다른 탭에서 로그아웃 버튼 눌러도 이미 띄운 탭에서는 데이터를 들고있으므로, 뭔가 콜을 보내기 전에 쿠키 생존 여부 재확인해야함
    // TODO : 모든 실패 http콜에 대해서 팝업 띄워야 함
    beforeMount() {
      this.$bus.$on('loading', this.setLoading);
      this.$bus.$on('login', this.login);
      this.$bus.$on('logout', this.logout);
      this.$bus.$on('refreshTokenAndRetryIfPossible', this.refreshTokenAndRetryIfPossible);
      const siengLoginInfoCookie = $cookies.get('siengLoginInfo');
      console.log('siengLoginInfoCookie');
      console.dir(siengLoginInfoCookie);
      if (siengLoginInfoCookie) {
        this.loginInfo = siengLoginInfoCookie;
      }
    }
  };
</script>

<style lang="scss">
  @import url("http://fonts.googleapis.com/earlyaccess/notosanskr.css");

  #app {
    font-family: 'Roboto', 'Noto Sans KR', 'Avenir', Helvetica, Arial, sans-serif;
  }
</style>